import { scrollToId } from '../../utilities/scrollToId';
import { NumberOfReviews } from '../../components/Product';

interface AverageStarRatingProps {
  businessUnitId: string | null;
  averageStarRating: number | null;
  numberOfReviews: NumberOfReviews;
  hasPositiveNumberReviews: boolean;
}

export default function AverageStarRating({
  averageStarRating,
  numberOfReviews,
  hasPositiveNumberReviews,
}: AverageStarRatingProps) {

  function renderTrustPilot(averageStarRating: number | null) {
    let label = '';
    let cssModifier = '';

    switch (averageStarRating) {
      case 1:
        label = 'one star rating';
        cssModifier = 'one';
        break;
      case 1.5:
        label = 'one and a half star rating';
        cssModifier = 'one-point-five';
        break;
      case 2:
        label = 'two star rating';
        cssModifier = 'two';
        break;
      case 2.5:
        label = 'two and a half star rating';
        cssModifier = 'two-point-five';
        break;
      case 3:
        label = 'three star rating';
        cssModifier = 'three';
        break;
      case 3.5:
        label = 'three and a half star rating';
        cssModifier = 'three-point-five';
        break;
      case 4:
        label = 'four star rating';
        cssModifier = 'four';
        break;
      case 4.5:
        label = 'four and a half star rating';
        cssModifier = 'four-point-five';
        break;
      case 5:
        label = 'five star rating';
        cssModifier = 'five';
        break;
      default:
        break;
    }

    const reviewCount =
      numberOfReviews?.Total && numberOfReviews?.Total > 1
        ? `See all ${numberOfReviews.Total} reviews`
        : 'See review';

    return (
      <>
        <div className="trustpilot-logo" />
        <div className="trustpilot-star-rating">
          <div
            className={`trustpilot-star-rating__stars trustpilot-star-rating__stars--${cssModifier}`}
          >
            <p className="sr-only">{label}</p>
          </div>
        </div>
        <div className="trustpilot-star-rating-label">
          <p>
            <strong>{averageStarRating}</strong> out of 5
          </p>
        </div>
        <div className="trustpilot-reviews-count">
          <p className="trustpilot-reviews-count__label">
            <>
              {/* Mobile */}
              <a
                className="d-block d-lg-none"
                href="#reviewsTab1"
                onClick={e => {
                  e.preventDefault();
                  scrollToId('reviewsTab1', 'product-tab--selected');
                }}
              >
                <span>{reviewCount}</span>
              </a>

              {/* Desktop */}
              <a
                className="d-none d-lg-block"
                href="#reviewsTab"
                onClick={e => {
                  e.preventDefault();
                  scrollToId('reviewsTab', 'product-tab--selected');
                }}
              >
                <span>{reviewCount}</span>
              </a>
            </>
          </p>
        </div>
      </>
    );
  }

  return (
    <div className="trustpilot-container">
      {hasPositiveNumberReviews && renderTrustPilot(averageStarRating)}
    </div>
  );
}
